export default [
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      pageTitle: "Home",
      breadcrumb: [
        {
          text: "",
        },
      ],
      resource: "Home",
      action: "read",
    },
  },
]
